import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ConnectorIcon } from '../../assets/icons/sidebar/sidebar-device.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';

import Local from './components/Local';

/**
 * Component for displaying connector rating management.
 * @returns {React.JSX.Element} Connector management component
 */
function ConnectorManagement() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('deviceHub');
  const { totalResults: localTotal } = useAppSelector((state) => state.connector);

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: t('connectorRating'),
        count: localTotal,
        icon: <ConnectorIcon />,
      }),
    );
  }, [dispatch, localTotal]);

  return (
    <div className="connector-management-wrap">
      <div className="connector-management-container">
        <div className="table-content">
          <Local />
        </div>
      </div>
    </div>
  );
}

export default ConnectorManagement;
